module.exports = __webpack_public_path__ + "img/login_dec02.5b60ecea.png";